import React from 'react';
import Icon from '@mdi/react';
import { mdiEmoticonNeutralOutline } from '@mdi/js';
import theme from '../theme'; 

export const DisengagedFaceIcon = size => (
  <Icon 
    size={size}
    path={mdiEmoticonNeutralOutline}
    title="Disengaged"
    color={theme.disengaged}
  />
);